<div class="card-header-mini mb-0">
  <h3 class="card-title">{{widgetData.title}}</h3>
  <a *ngIf="widgetData.allLinkUrl" href="{{widgetData.allLinkUrl}}" target="{{widgetData.allLinkTarget}}" class="more-link">{{widgetData.allLinkText}}</a>
</div>

<mat-table *ngIf="assignments.length && !loading && !isServerError" [dataSource]="assignments" class="assignments-widget-table">
  <ng-container matColumnDef="text">
    <mat-cell *matCellDef="let element" class="align-items-flex-start">
      <div class="assigment-title-container">
        <div class="title">
          <a *ngIf="element.titleUrl" href="{{element.titleUrl}}">{{ element.title }}</a>
          <span *ngIf="!element.titleUrl">{{ element.title }}</span>
        </div>
        <div *ngIf="!element.descriptionUrl" class="description">{{ element.description }}</div>
          <a *ngIf="element.descriptionUrl" class="description" href="{{element.descriptionUrl}}">{{ element.description }}</a>

        <div *ngIf="element.state" class="mt-1">
          <span class="badge primary-orange d-not-phone-none">
            {{ element.state }}
          </span>
        </div>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="date">
    <mat-cell *matCellDef="let element" class="date-td align-items-flex-start">
      <div class="fs-14">
        <div><strong>{{widgetData.submitDueDateText}}</strong> {{ element.date | dayOfWeek }}, {{ element.date | date: 'shortDate' }},</div>
        <div>{{widgetData.timeText}} {{ element.date | date: 'shortTime' }}</div>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="state">
    <mat-cell *matCellDef="let element" class="justify-content-end align-items-flex-start d-phone-none state-td">
      <div *ngIf="element.state" class="badge primary-orange">
        {{ element.state }}
      </div>
    </mat-cell>
  </ng-container>

  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<div *ngIf="!assignments.length && !loading && !isServerError">{{widgetData.noAssignmentsText}}</div>

<mat-table *ngIf="loading && !isServerError" [dataSource]="assignments" class="assignments-widget-table">
  <ng-container matColumnDef="text">
    <mat-cell *matCellDef="let element" class="align-items-flex-start">
      <div class="assigment-title-container">
        <div class="title">
          <app-skeleton [type]="'text'" [symbolsCount]="20"/>
        </div>
        <app-skeleton class="description" [type]="'text'" [symbolsCount]="20"/>

        <div class="mt-1 d-not-phone-none">
          <app-skeleton [width]="60" [height]="30"/>
        </div>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="date">
    <mat-cell *matCellDef="let element" class="date-td align-items-flex-start">
      <div class="fs-14">
        <app-skeleton [type]="'text'" [symbolsCount]="20"/>
        <app-skeleton [type]="'text'" [symbolsCount]="8"/>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="state">
    <mat-cell *matCellDef="let element" class="justify-content-end align-items-flex-start d-phone-none state-td">
      <app-skeleton [width]="80" [height]="30" [borderRadius]="15"/>
    </mat-cell>
  </ng-container>

  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>